import { Skeleton } from './skeleton';
import Container from '~/components/atoms/Container';

// Hero Stats Skeleton
export function HeroStatsSkeleton() {
    return (
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-40 flex flex-col items-start">
            <div className="text-sm mb-2 px-4 py-1 bg-white/50 rounded-full border-white/60 border-2">
                <Skeleton className="h-4 w-24 inline-block" />
                <span className="ml-1">offices in your region</span>
            </div>
            <Skeleton className="h-12 w-96 mb-6" />
            <Skeleton className="h-6 w-80 mb-4" />
            <Skeleton className="h-12 w-48" />
        </div>
    );
}

// Stats Counter Skeleton (Mobile)
export function StatsCounterSkeleton() {
    return (
        <div className="flex items-center justify-center gap-3 mt-28 mb-8">
            {/* Avatars */}
            <div className="flex -space-x-3">
                <Skeleton className="w-10 h-10 rounded-full" />
                <Skeleton className="w-10 h-10 rounded-full" />
                <Skeleton className="w-10 h-10 rounded-full" />
            </div>
            <div>
                <Skeleton className="h-5 w-20 mb-1" />
                <Skeleton className="h-3 w-24" />
            </div>
            <div className="flex items-center px-3 py-2 rounded-md">
                <Skeleton className="w-4 h-4 mr-2" />
                <Skeleton className="h-4 w-8" />
            </div>
        </div>
    );
}

// Properties Skeleton
export function PropertiesSkeleton() {
    return (
        <Container htmlFor="ultra-wide">
            <div className="my-12 px-4">
                <Skeleton className="h-8 w-64 mb-6" />
                <div className="flex overflow-x-auto scrollbar-hide gap-4">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="flex-shrink-0 w-80">
                            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <Skeleton className="h-48 w-full" />
                                <div className="p-4">
                                    <Skeleton className="h-5 w-3/4 mb-2" />
                                    <Skeleton className="h-4 w-full mb-2" />
                                    <Skeleton className="h-4 w-1/2 mb-4" />
                                    <div className="flex justify-between items-center">
                                        <Skeleton className="h-4 w-24" />
                                        <Skeleton className="h-6 w-20" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
}

// Featured Places Skeleton
export function FeaturedPlacesSkeleton() {
    return (
        <Container htmlFor="ultra-wide">
            <div className="py-12 px-4">
                <Skeleton className="h-8 w-64 mb-8" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="bg-white rounded-lg shadow-sm overflow-hidden">
                            <Skeleton className="h-48 w-full" />
                            <div className="p-4">
                                <Skeleton className="h-5 w-3/4 mb-2" />
                                <Skeleton className="h-4 w-full mb-2" />
                                <Skeleton className="h-4 w-1/2 mb-4" />
                                <div className="flex justify-between items-center">
                                    <Skeleton className="h-4 w-24" />
                                    <Skeleton className="h-6 w-20" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
}

// Partners Skeleton
export function PartnersSkeleton() {
    return (
        <Container htmlFor="ultra-wide">
            <div className="py-12 px-4">
                <Skeleton className="h-8 w-64 mb-8" />
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
                    {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center">
                            <Skeleton className="h-16 w-24" />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
}

// Listings Skeleton
export function ListingsSkeleton() {
    return (
        <Container htmlFor="ultra-wide">
            <div className="py-12 px-4">
                <Skeleton className="h-8 w-64 mb-8" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {Array.from({ length: 9 }).map((_, i) => (
                        <div key={i} className="bg-white rounded-lg shadow-sm overflow-hidden">
                            <Skeleton className="h-48 w-full" />
                            <div className="p-4">
                                <Skeleton className="h-5 w-3/4 mb-2" />
                                <Skeleton className="h-4 w-full mb-2" />
                                <Skeleton className="h-4 w-1/2 mb-4" />
                                <div className="flex justify-between items-center">
                                    <Skeleton className="h-4 w-24" />
                                    <Skeleton className="h-6 w-20" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
}

// Blogs Skeleton
export function BlogsSkeleton() {
    return (
        <div className="py-10 bg-gray-50">
            <Container htmlFor="ultra-wide">
                <div className="px-4">
                    <Skeleton className="h-8 w-64 mb-8" />
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="bg-white rounded-lg shadow-sm overflow-hidden">
                                <Skeleton className="h-48 w-full" />
                                <div className="p-4">
                                    <Skeleton className="h-5 w-3/4 mb-2" />
                                    <Skeleton className="h-4 w-full mb-2" />
                                    <Skeleton className="h-4 w-1/2 mb-4" />
                                    <div className="flex justify-between items-center">
                                        <Skeleton className="h-4 w-24" />
                                        <Skeleton className="h-6 w-20" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
}

// About Section Skeleton
export function AboutSectionSkeleton() {
    return (
        <div className="py-16 bg-white">
            <Container htmlFor="ultra-wide">
                <div className="px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <Skeleton className="h-8 w-64 mb-4" />
                            <Skeleton className="h-6 w-full mb-2" />
                            <Skeleton className="h-6 w-full mb-2" />
                            <Skeleton className="h-6 w-3/4 mb-8" />
                            <Skeleton className="h-12 w-32" />
                        </div>
                        <div>
                            <Skeleton className="h-64 w-full rounded-lg" />
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
}
